import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
} from '@mui/material';
import InquiryForm from './InquiryForm'; 

const BACKGROUND_IMAGE =
  'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1920&q=80';

const InquiryPage = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        py: { xs: 8, md: 12 },
        backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.1) 100%), url(${BACKGROUND_IMAGE})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {/* LEFT COLUMN: Clean Serif Title & Subtitle */}
          <Grid item xs={12} md={6}>
            <Box sx={{ maxWidth: 480, color: '#ffffff' }}>
              <Typography
                variant="h2"
                sx={{
                  fontFamily: '"Georgia", "Playfair Display", serif',
                  fontWeight: 500,
                  fontSize: { xs: '2.5rem', sm: '3.2rem', md: '3.8rem' },
                  lineHeight: 1.15,
                  mb: 3,
                  letterSpacing: '-0.01em',
                  textShadow: '0 2px 10px rgba(0,0,0,0.3)',
                }}
              >
                Need help choosing your destination?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.15rem' },
                  fontWeight: 600,
                  color: 'rgba(255, 255, 255, 0.95)',
                  textShadow: '0 1px 5px rgba(0,0,0,0.3)',
                }}
              >
                Speak to our travel expert for a trip tailored just for you.
              </Typography>
            </Box>
          </Grid>

          {/* RIGHT COLUMN: Full-Featured Form */}
          <Grid item xs={12} md={6}>
            <InquiryForm variant="desktop" />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default InquiryPage;